import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.2/js/sparta-events-utility";
import _ from "utilities/vendor/lodash/4.13.1/js/lodash.custom.min";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/2.0.2/js/sparta-mediaquery-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.0.3/js/sparta-store-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";






class ShareContent {









  breakpoint(data, viewport) {
    const currentViewport = viewport || spartaMediaQueryUtility.matchedQuery.viewport;
    const $nodes = $(`[data-rwd-content=${data.content}]`);

    let $content = $nodes.filter('[data-rwd-content-current="true"]').children().clone(true);

    switch (data.action) {
      case 'move':
        $content = $nodes.filter('[data-rwd-content-current="true"]').children();
        $nodes
          .empty().removeAttr('data-rwd-content-current')
          .each(function eachNode() {
            const $node = $(this);
            const criterion = $node.attr('data-rwd-content-rule');

            if ($.inArray(currentViewport, data.viewports[criterion]) > -1) {
              $node.append($content).attr('data-rwd-content-current', 'true');
            }
          });
        break;
      default:
    }

    if (typeof data.callback === 'function') {
      data.callback();
    }
  }

  init(options) {
    const defaults = {
      content: '',
      criterion: '',
      action: '',
      viewports: {
        small: ['small'],
        medium: ['medium'],
        large: ['large', 'largeCentered', 'xlarge', 'xxlarge'],
        'not-small': ['medium', 'large', 'largeCentered', 'xlarge', 'xxlarge'],
        'not-large': ['small', 'medium'],
        all: ['small', 'medium', 'large', 'largeCentered', 'xlarge', 'xxlarge'],
      },
    };

    const data = {};
    Object.assign(data, defaults, options);

    switch (data.criterion) {
      case 'breakpoint':
        spartaEventsUtility.sub(spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE,
          resp => this.breakpoint(data, resp.data.viewport));

        _.delay(() => this.breakpoint(data), 0);
        break;
      default:
    }
  }
}

export default new ShareContent();
